import { render, staticRenderFns } from "./QuestionsManagement.vue?vue&type=template&id=c2478ad6&"
import script from "./questions-management.ts?vue&type=script&lang=ts&"
export * from "./questions-management.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports